import {atom} from 'recoil';

export default {
  dailyTip: atom({
    key: 'dailyTip',
    default: null,
  }),
};
